import { queryFilter } from '../../hooks/useQueryFilters';
import type { CommercialBooleanFilterValue } from '../../constants/commercialFilters';

export const ONBOARDING_QUERY_FILTER_SCHEMA = {
  page: queryFilter.integer(1, { min: 1 }),
  searchName: queryFilter.string(),
  classifications: queryFilter.array<string>(),
  projectCodes: queryFilter.array<string>(),
  hasPhotos: queryFilter.enum<CommercialBooleanFilterValue>('', ['', 'yes', 'no']),
  hasParq: queryFilter.enum<CommercialBooleanFilterValue>('', ['', 'yes', 'no']),
  hasAnamnesis: queryFilter.enum<CommercialBooleanFilterValue>('', ['', 'yes', 'no']),
  joinedAtStart: queryFilter.string(),
  joinedAtEnd: queryFilter.string(),
};
